/**
 * @typedef {('xxl'|'xl'|'lg'|'md'|'sm'|'xs')} ViewportSizeType
 */

/** @type {{ [K in ViewportSizeType]: ViewportSizeType }} */
const viewportSize = {
    xxl: 'xxl',
    xl: 'xl',
    lg: 'lg',
    md: 'md',
    sm: 'sm',
    xs: 'xs',
}
export default viewportSize;